/* Circ products — Swiper slider. Peeking slides (2.8 on desktop by default). */
(function () {
  const SWIPER_SRC = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
  let swiperPromise;

  // Keep the 44KB carousel library off the mobile critical path until its
  // below-fold section is close enough for the shopper to reach it.
  function loadSwiper() {
    if (typeof Swiper !== "undefined") return Promise.resolve();
    if (swiperPromise) return swiperPromise;

    swiperPromise = new Promise(function (resolve, reject) {
      const script = document.createElement("script");
      script.src = SWIPER_SRC;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return swiperPromise;
  }

  function init() {
    document.querySelectorAll("[data-sst-products]").forEach(function (el) {
      if (el.dataset.sstInit === "true") return;
      el.dataset.sstInit = "true";

      const slideCount = el.querySelectorAll(".swiper-slide").length;
      const mobilePerView = parseFloat(el.dataset.perViewMobile) || 1;
      const tabletPerView = parseFloat(el.dataset.perViewTablet) || 2;
      const desktopPerView = parseFloat(el.dataset.perViewDesktop) || 2.8;
      const desktopLoopMin = Math.ceil(desktopPerView) * 2;
      const desktopShortList = slideCount <= Math.ceil(desktopPerView);
      const desktopGap = 80;
      const desktopGapTotal = Math.max(slideCount - 1, 0) * desktopGap;

      el.style.setProperty(
        "--sst-products-short-slide-width",
        `min(620px, calc(${100 / slideCount}% - ${desktopGapTotal / slideCount}px))`,
      );
      el.classList.toggle(
        "sst-products__slider--desktop-short",
        desktopShortList,
      );

      // Swiper needs slideCount >= 2x slidesPerView to loop cleanly, and
      // fewer slides than slidesPerView breaks centered/peeking layout.
      const canLoop =
        el.dataset.loop === "true" &&
        !desktopShortList &&
        slideCount >= desktopLoopMin;

      const nav = el.parentElement.querySelector(".sst-products__nav");

      new Swiper(el, {
        slidesPerView: Math.min(mobilePerView, slideCount),
        spaceBetween: 24,
        loop: canLoop,
        grabCursor: true,
        watchOverflow: true,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        centeredSlides: slideCount > mobilePerView,
        navigation: nav
          ? {
              nextEl: nav.querySelector(".sst-products__nav-button--next"),
              prevEl: nav.querySelector(".sst-products__nav-button--prev"),
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: Math.min(tabletPerView, slideCount),
            spaceBetween: 32,
            centeredSlides: slideCount > tabletPerView,
          },
          990: {
            slidesPerView: desktopShortList
              ? slideCount
              : Math.min(desktopPerView, slideCount),
            spaceBetween: desktopGap,
            centeredSlides: !desktopShortList && slideCount > desktopPerView,
          },
        },
      });
    });
  }

  function initWhenNearViewport() {
    const sliders = document.querySelectorAll("[data-sst-products]");
    if (!sliders.length) return;

    if (!("IntersectionObserver" in window)) {
      loadSwiper().then(init);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        loadSwiper().then(init);
      },
      { rootMargin: "600px 0px" },
    );

    sliders.forEach(function (slider) {
      observer.observe(slider);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWhenNearViewport);
  } else {
    initWhenNearViewport();
  }

  // Theme editor re-render
  document.addEventListener("shopify:section:load", function () {
    loadSwiper().then(init);
  });
})();
